import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { TitleProvider } from "./context/TitleContext";
import Footer from "./pages/Footer";
import Home from "./pages/Home/Home";
import Layout from "./pages/Layout";

import LoginPage from "./pages/Auth/Login";
import Profile from "./pages/Profile";
import Roles from "./pages/Roles";
import AddRole from "./pages/AddRole";
import EditRole from "./pages/EditRole";
import Teachers from "./pages/Teachers";
import AddTeacher from "./pages/AddTeacher";
import EditTeacher from "./pages/EditTeacher";
import StudyMaterials from "./pages/StudyMaterials";
import AddStudyMaterial from "./pages/AddStudyMaterial";
import EditStudyMaterial from "./pages/EditStudyMaterial";

import PrivateRoute from "./components/PrivateRoute";
import PermissionRoute from "./components/PermissionRoute";
import AutoRedirect from "./components/AutoRedirect";
import Category from "./components/Category/Category";
import AddCategory from "./components/Category/AddCategory";
import EditCategory from "./components/Category/EditCategory";
import Notifications from "./pages/Notifications";

import AboutUsForm from "./pages/AboutUS/AboutUS";
import Hero from "./pages/Hero";
import ProductForm from "./pages/Products/Products";
import GeneralProducts from "./pages/Products/GeneralProducts";
import DigitalCodes from "./pages/Products/DigitalCodes";
import AddProductPage from "./pages/Products/AddProductPage";
import EditProductPage from "./pages/Products/EditProductPage";
import Orders from "./pages/Orders";
import NoPermission from "./pages/NoPermission";
import Admins from "./components/Admins/Admins";
import AddAdmin from "./components/Admins/AddAdmin";
import EditAdmin from "./components/Admins/EditAdmin";
import Cities from "./components/Cities/Cities";
import AddCity from "./components/Cities/AddCity";
import EditCity from "./components/Cities/EditCity";
import AddFeature from "./components/Features/AddFeature";
import EditFeature from "./components/Features/EditFeature";
import Features from "./components/Features/Features";
import AddGrade from "./components/Grades/AddGrade";
import EditGrade from "./components/Grades/EditGrade";
import Grades from "./components/Grades/Grades";
import AddRegion from "./components/Regions/AddRegion";
import EditRegion from "./components/Regions/EditRegion";
import Regions from "./components/Regions/Regions";
import AddUser from "./components/Users/AddUser";
import EditUser from "./components/Users/EditUser";
import Users from "./components/Users/Users";
import UserDetails from "./components/Users/UserDetails";

// الصفحات الجديدة
import Contacts from "./components/Contacts/Contacts";
import FAQs from "./components/FAQs/FAQs";
import Messages from "./pages/Messages";
import Sections from "./pages/Sections";
import SliderTexts from "./pages/SliderTexts";
import TeacherCodes from "./components/TeacherCodes/TeacherCodes";
import AddTeacherCodes from "./components/TeacherCodes/AddTeacherCode";
import EditTeacherCodes from "./components/TeacherCodes/EditTeacherCode";
import EditTerms from "./pages/Terms/EditTerms";
import EditPrivacy from "./pages/Terms/EditPrivacy";
import Coupons from "./components/Coupons/Coupons";
import AddCoupon from "./components/Coupons/AddCoupon";
import EditCoupon from "./components/Coupons/EditCoupon";
import Wallets from "./pages/Wallets/Wallets";
import AdminWallets from "./pages/Wallets/AdminWallets";

import Transfers from "./pages/Wallets/Transfers";
import DailySales from "./pages/Reports/DailySales";
import Variants from "./pages/Products/Variants";

function App() {
  return (
    <>
      <TitleProvider>
        <Router>
          <Routes>
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <Layout />
                </PrivateRoute>
              }
            >
              <Route
                index
                element={
                  <PrivateRoute>
                    <AutoRedirect>
                      <PermissionRoute permissionName="view-dashboard">
                        <Home />
                      </PermissionRoute>
                    </AutoRedirect>
                  </PrivateRoute>
                }
              />
              <Route
                path="/profile"
                element={
                  <PrivateRoute>
                    <PermissionRoute permissionName="view-dashboard">
                      <Profile />
                    </PermissionRoute>
                  </PrivateRoute>
                }
              />
              <Route
                path="/roles"
                element={
                  <PrivateRoute>
                    <PermissionRoute permissionName="view-roles">
                      <Roles />
                    </PermissionRoute>
                  </PrivateRoute>
                }
              />
              <Route
                path="/add-role"
                element={
                  <PrivateRoute>
                    <PermissionRoute permissionName="create-roles">
                      <AddRole />
                    </PermissionRoute>
                  </PrivateRoute>
                }
              />
              <Route
                path="/edit-role/:id"
                element={
                  <PrivateRoute>
                    <PermissionRoute permissionName="edit-roles">
                      <EditRole />
                    </PermissionRoute>
                  </PrivateRoute>
                }
              />

              {/* Teachers Routes */}
              <Route
                path="/teachers"
                element={
                  <PrivateRoute>
                    <PermissionRoute permissionName="view-teachers">
                      <Teachers />
                    </PermissionRoute>
                  </PrivateRoute>
                }
              />
              <Route
                path="/add-teacher"
                element={
                  <PrivateRoute>
                    <PermissionRoute permissionName="create-teachers">
                      <AddTeacher />
                    </PermissionRoute>
                  </PrivateRoute>
                }
              />
              <Route
                path="/edit-teacher/:id"
                element={
                  <PrivateRoute>
                    <PermissionRoute permissionName="edit-teachers">
                      <EditTeacher />
                    </PermissionRoute>
                  </PrivateRoute>
                }
              />

              {/* Study Materials Routes */}
              <Route
                path="/study-materials"
                element={
                  <PrivateRoute>
                    <PermissionRoute permissionName="view-subjects">
                      <StudyMaterials />
                    </PermissionRoute>
                  </PrivateRoute>
                }
              />
              <Route
                path="/add-study-material"
                element={
                  <PrivateRoute>
                    <PermissionRoute permissionName="create-subjects">
                      <AddStudyMaterial />
                    </PermissionRoute>
                  </PrivateRoute>
                }
              />
              <Route
                path="/edit-study-material/:id"
                element={
                  <PrivateRoute>
                    <PermissionRoute permissionName="edit-subjects">
                      <EditStudyMaterial />
                    </PermissionRoute>
                  </PrivateRoute>
                }
              />

              {/* Category Routes */}
              <Route
                path="/category"
                element={
                  <PrivateRoute>
                    <PermissionRoute permissionName="view-categories">
                      <Category />
                    </PermissionRoute>
                  </PrivateRoute>
                }
              />
              <Route
                path="/add_category"
                element={
                  <PrivateRoute>
                    <PermissionRoute permissionName="create-categories">
                      <AddCategory />
                    </PermissionRoute>
                  </PrivateRoute>
                }
              />
              <Route
                path="/edit_category/:id"
                element={
                  <PrivateRoute>
                    <PermissionRoute permissionName="edit-categories">
                      <EditCategory />
                    </PermissionRoute>
                  </PrivateRoute>
                }
              />

              {/* Contacts Routes - الجديدة */}
              <Route
                path="/contacts"
                element={
                  <PrivateRoute>
                    <PermissionRoute permissionName="view-contacts">
                      <Contacts />
                    </PermissionRoute>
                  </PrivateRoute>
                }
              />

              {/* FAQs Routes - الجديدة */}
              <Route
                path="/faqs"
                element={
                  <PrivateRoute>
                    <PermissionRoute permissionName="view-faqs">
                      <FAQs />
                    </PermissionRoute>
                  </PrivateRoute>
                }
              />

              {/* Messages Routes - جديدة */}
              <Route
                path="/messages"
                element={
                  <PrivateRoute>
                    <PermissionRoute permissionName="view-messages">
                      <Messages />
                    </PermissionRoute>
                  </PrivateRoute>
                }
              />

              {/* Sections Routes - جديدة */}
              <Route
                path="/sections"
                element={
                  <PrivateRoute>
                    <PermissionRoute permissionName="view-sections">
                      <Sections />
                    </PermissionRoute>
                  </PrivateRoute>
                }
              />

              {/* Slider Texts Routes - جديدة */}
              <Route
                path="/slider-texts"
                element={
                  <PrivateRoute>
                    <SliderTexts />
                  </PrivateRoute>
                }
              />

              {/* <Route
                path="/notifications"
                element={
                  <PrivateRoute>
                    <Notifications />
                  </PrivateRoute>
                }
              /> */}

              <Route
                path="/about-us"
                element={
                  <PrivateRoute>
                    <PermissionRoute permissionName="manage-settings">
                      <AboutUsForm />
                    </PermissionRoute>
                  </PrivateRoute>
                }
              />
              <Route
                path="/hero"
                element={
                  <PrivateRoute>
                    <PermissionRoute permissionName="view-sliders">
                      <Hero />
                    </PermissionRoute>
                  </PrivateRoute>
                }
              />
              <Route
                path="/products"
                element={
                  <PrivateRoute>
                    <PermissionRoute permissionName="view-products">
                      <ProductForm />
                    </PermissionRoute>
                  </PrivateRoute>
                }
              />
              <Route
                path="/general-products"
                element={
                  <PrivateRoute>
                    <PermissionRoute permissionName="view-products">
                      <GeneralProducts />
                    </PermissionRoute>
                  </PrivateRoute>
                }
              />
              <Route
                path="/digital-codes"
                element={
                  <PrivateRoute>
                    <PermissionRoute permissionName="view-products">
                      <DigitalCodes />
                    </PermissionRoute>
                  </PrivateRoute>
                }
              />
              <Route
                path="/products/add"
                element={
                  <PrivateRoute>
                    <PermissionRoute permissionName="create-products">
                      <AddProductPage />
                    </PermissionRoute>
                  </PrivateRoute>
                }
              />
              <Route
                path="/products/edit/:id"
                element={
                  <PrivateRoute>
                    <PermissionRoute permissionName="edit-products">
                      <EditProductPage />
                    </PermissionRoute>
                  </PrivateRoute>
                }
              />

              <Route
                path="/teachers_codes"
                element={
                  <PrivateRoute>
                    <PermissionRoute permissionName="get-teacher-codes">
                      <TeacherCodes />
                    </PermissionRoute>
                  </PrivateRoute>
                }
              />
              <Route
                path="/add_teacher_code"
                element={
                  <PrivateRoute>
                    <PermissionRoute permissionName="create-teacher-codes">
                      <AddTeacherCodes />
                    </PermissionRoute>
                  </PrivateRoute>
                }
              />
              <Route
                path="/edit_teacher_code/:id"
                element={
                  <PrivateRoute>
                    <PermissionRoute permissionName="edit-teacher-codes">
                      <EditTeacherCodes />
                    </PermissionRoute>
                  </PrivateRoute>
                }
              />
              <Route
                path="/orders"
                element={
                  <PrivateRoute>
                    <PermissionRoute permissionName="view-orders">
                      <Orders />
                    </PermissionRoute>
                  </PrivateRoute>
                }
              />
              {/* صفحة طلبات الكتب فقط */}
              <Route
                path="/orders/books"
                element={
                  <PrivateRoute>
                    <PermissionRoute permissionName="view-orders">
                      <Orders fixedOrderType="book" />
                    </PermissionRoute>
                  </PrivateRoute>
                }
              />
              {/* صفحة طلبات الأكواد فقط */}
              <Route
                path="/orders/codes"
                element={
                  <PrivateRoute>
                    <PermissionRoute permissionName="view-orders">
                      <Orders fixedOrderType="code" />
                    </PermissionRoute>
                  </PrivateRoute>
                }
              />
              {/* admins Routes */}
              <Route
                path="/admins"
                element={
                  <PrivateRoute>
                    <PermissionRoute permissionName="view-admins">
                      <Admins />
                    </PermissionRoute>
                  </PrivateRoute>
                }
              />
              <Route
                path="/add-admin"
                element={
                  <PrivateRoute>
                    <PermissionRoute permissionName="create-admins">
                      <AddAdmin />
                    </PermissionRoute>
                  </PrivateRoute>
                }
              />
              <Route
                path="/edit-admin/:id"
                element={
                  <PrivateRoute>
                    <PermissionRoute permissionName="edit-admins">
                      <EditAdmin />
                    </PermissionRoute>
                  </PrivateRoute>
                }
              />
              {/* users Routes */}
              <Route
                path="/users"
                element={
                  <PrivateRoute>
                    <PermissionRoute permissionName="view-users">
                      <Users />
                    </PermissionRoute>
                  </PrivateRoute>
                }
              />
              <Route
                path="/add-user"
                element={
                  <PrivateRoute>
                    <PermissionRoute permissionName="create-users">
                      <AddUser />
                    </PermissionRoute>
                  </PrivateRoute>
                }
              />
              <Route
                path="/edit-user/:id"
                element={
                  <PrivateRoute>
                    <PermissionRoute permissionName="edit-users">
                      <EditUser />
                    </PermissionRoute>
                  </PrivateRoute>
                }
              />
              <Route
                path="/user-details/:id"
                element={
                  <PrivateRoute>
                    <PermissionRoute permissionName="view-users">
                      <UserDetails />
                    </PermissionRoute>
                  </PrivateRoute>
                }
              />
              <Route
                path="/notifications"
                element={
                  <PrivateRoute>
                    <PermissionRoute permissionName="view-notifications">
                      <Notifications />
                    </PermissionRoute>
                  </PrivateRoute>
                }
              />
              {/* cities Routes */}
              <Route
                path="/cities"
                element={
                  <PrivateRoute>
                    <PermissionRoute permissionName="view-cities">
                      <Cities />
                    </PermissionRoute>
                  </PrivateRoute>
                }
              />
              <Route
                path="/add-city"
                element={
                  <PrivateRoute>
                    <PermissionRoute permissionName="create-cities">
                      <AddCity />
                    </PermissionRoute>
                  </PrivateRoute>
                }
              />
              <Route
                path="/edit-city/:id"
                element={
                  <PrivateRoute>
                    <PermissionRoute permissionName="edit-cities">
                      <EditCity />
                    </PermissionRoute>
                  </PrivateRoute>
                }
              />
              {/* features Routes */}
              <Route
                path="/add-feature"
                element={
                  <PrivateRoute>
                    <PermissionRoute permissionName="create-features">
                      <AddFeature />
                    </PermissionRoute>
                  </PrivateRoute>
                }
              />
              <Route
                path="/edit-feature/:id"
                element={
                  <PrivateRoute>
                    <PermissionRoute permissionName="edit-features">
                      <EditFeature />
                    </PermissionRoute>
                  </PrivateRoute>
                }
              />
              <Route
                path="/features"
                element={
                  <PrivateRoute>
                    <PermissionRoute permissionName="view-features">
                      <Features />
                    </PermissionRoute>
                  </PrivateRoute>
                }
              />
              {/* grades Routes */}
              <Route
                path="/add-grade"
                element={
                  <PrivateRoute>
                    <PermissionRoute permissionName="create-grades">
                      <AddGrade />
                    </PermissionRoute>
                  </PrivateRoute>
                }
              />
              <Route
                path="/edit-grade/:id"
                element={
                  <PrivateRoute>
                    <PermissionRoute permissionName="edit-grades">
                      <EditGrade />
                    </PermissionRoute>
                  </PrivateRoute>
                }
              />
              <Route
                path="/grades"
                element={
                  <PrivateRoute>
                    <PermissionRoute permissionName="view-grades">
                      <Grades />
                    </PermissionRoute>
                  </PrivateRoute>
                }
              />
              {/* regions Routes */}
              <Route
                path="/add-region"
                element={
                  <PrivateRoute>
                    <PermissionRoute permissionName="create-regions">
                      <AddRegion />
                    </PermissionRoute>
                  </PrivateRoute>
                }
              />
              <Route
                path="/edit-region/:id"
                element={
                  <PrivateRoute>
                    <PermissionRoute permissionName="edit-regions">
                      <EditRegion />
                    </PermissionRoute>
                  </PrivateRoute>
                }
              />
              <Route
                path="/regions"
                element={
                  <PrivateRoute>
                    <PermissionRoute permissionName="view-regions">
                      <Regions />
                    </PermissionRoute>
                  </PrivateRoute>
                }
              />

              {/* Coupons Routes */}
              <Route
                path="/coupons"
                element={
                  <PrivateRoute>
                    <Coupons />
                  </PrivateRoute>
                }
              />
              <Route
                path="/add-coupon"
                element={
                  <PrivateRoute>
                    <AddCoupon />
                  </PrivateRoute>
                }
              />
              <Route
                path="/edit-coupon/:id"
                element={
                  <PrivateRoute>
                    <EditCoupon />
                  </PrivateRoute>
                }
              />

              {/* Wallets Routes */}
              <Route
                path="/wallets"
                element={
                  <PrivateRoute>
                    <PermissionRoute permissionName="view-wallets">
                      <Wallets />
                    </PermissionRoute>
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin-wallets"
                element={
                  <PrivateRoute>
                    <PermissionRoute permissionName="view-treasuries">
                      <AdminWallets />
                    </PermissionRoute>
                  </PrivateRoute>
                }
              />
              <Route
                path="/daily-supplies"
                element={<Navigate to="/transfers" replace />}
              />
              <Route
                path="/transfers"
                element={
                  <PrivateRoute>
                    <PermissionRoute permissionName="view-treasuries">
                      <Transfers />
                    </PermissionRoute>
                  </PrivateRoute>
                }
              />
              <Route
                path="/product-variants"
                element={
                  <PrivateRoute>
                    <PermissionRoute permissionName="view-products">
                      <Variants />
                    </PermissionRoute>
                  </PrivateRoute>
                }
              />

              {/* Reports Routes */}
              <Route
                path="/reports/daily-sales"
                element={
                  <PrivateRoute>
                    <PermissionRoute permissionName="view-sales-reports">
                      <DailySales />
                    </PermissionRoute>
                  </PrivateRoute>
                }
              />

              {/* Legal Pages */}
              <Route
                path="/terms"
                element={
                  <PrivateRoute>
                    <PermissionRoute permissionName="update-terms">
                      <EditTerms />
                    </PermissionRoute>
                  </PrivateRoute>
                }
              />

              <Route
                path="/privacy"
                element={
                  <PrivateRoute>
                    <PermissionRoute permissionName="update-privacy">
                      <EditPrivacy />
                    </PermissionRoute>
                  </PrivateRoute>
                }
              />
            </Route>


            <Route path="login" element={<LoginPage />} />
            <Route path="no-permission" element={<NoPermission />} />
          </Routes>
          <Footer />
        </Router>
        <ToastContainer
          position="top-center"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={true}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          style={{ zIndex: 9999 }}
        />
      </TitleProvider>
    </>
  );
}

export default App;
